export const Tofixed = (value) => {
  return parseFloat(value ? value : 0).toFixed(2)
  // return Math.round(value ? value : 0)
}

export const RemoveDecimmal = (value) => {
  //return parseFloat(value ? value : 0).toFixed(2)
  return Math.round(value ? value : 0)
}